module.exports = __webpack_public_path__ + "static/media/odometer1.e4ffcdca.png";